import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useAuth } from "@/contexts/AuthContext"
import { registerClass } from "@/services/generatedAPIs"
import React from "react"
import { WithTranslation, withTranslation } from "react-i18next"
import { useSWRConfig } from "swr"
import { useAsyncAction } from "@/hooks/use-async-action"
import { toast } from "sonner"

function CreateClassroomDialog({
    t,
    ...props
}: WithTranslation) {
  const { getCurrentUser } = useAuth();
  const { mutate } = useSWRConfig();
  const { isLoading, execute } = useAsyncAction({ showErrorToast: false });
  const [open, setOpen] = React.useState(false);

  const onSubmit = (formData: FormData) => {
    const name = formData.get("name") as string;
    if (!name || !name.trim()) {
      toast.error(t('component.alert'));
      return;
    }

    execute(async () => {
      const schoolName = getCurrentUser()!.schoolName;
      const res = await registerClass({
        name: name.trim(),
        schoolName,
        override: false,
      });
      if (res.code === 200) {
        console.log("Create classroom successful", res.data);
        mutate("AdminPage-useGetAllClassInfo");
        setOpen(false);
      } else {
        console.error("Create classroom failed", res.code, res.message);
        toast.error(t('common.apierror') + res.message);
      }
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="default" className="bg-primary">{t("component.createclass")}</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <form action={onSubmit}>
          <DialogHeader>
            <DialogTitle>{t("component.createclass")}</DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                {t("component.classname")}
              </Label>
              <Input name="name" className="col-span-3" required />
            </div>
          </div>
          <DialogFooter>
            <Button type="submit" variant="outline" loading={isLoading}>{t("component.done")}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default withTranslation()(CreateClassroomDialog);
